<div class="glass-panel flex w-full flex-col gap-4 rounded-xl p-5 shadow-2xl">
  <!-- Navegação entre meses -->
  <div class="flex items-center justify-between">
    <button
      type="button"
      aria-label="Mês anterior"
      class="active-press flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-on-surface transition-colors hover:bg-surface-container-highest hover:text-primary disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-on-surface"
      [disabled]="!canGoToPreviousMonth()"
      (click)="previousMonth()"
    >
      <span class="material-symbols-outlined">chevron_left</span>
    </button>

    <span class="font-headline-sm text-headline-sm uppercase tracking-wider text-on-surface" aria-live="polite">
      {{ monthLabel() }}
    </span>

    <button
      type="button"
      aria-label="Próximo mês"
      class="active-press flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-on-surface transition-colors hover:bg-surface-container-highest hover:text-primary disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-on-surface"
      [disabled]="!canGoToNextMonth()"
      (click)="nextMonth()"
    >
      <span class="material-symbols-outlined">chevron_right</span>
    </button>
  </div>

  <!-- Dias da semana -->
  <div class="grid grid-cols-7 gap-1 text-center" aria-hidden="true">
    @for (initial of weekdayInitials; track $index) {
      <span class="font-label-mono text-xs text-on-surface-variant">{{ initial }}</span>
    }
  </div>

  <!-- Dias do mês (classes literais por estado — ver regra de classes dinâmicas no CLAUDE.md) -->
  <div class="grid grid-cols-7 gap-1">
    @for (cell of cells(); track $index) {
      @if (cell) {
        @switch (cell.state) {
          @case ('selected') {
            <button
              type="button"
              aria-pressed="true"
              [attr.aria-label]="cell.ariaLabel"
              [attr.aria-current]="cell.isToday ? 'date' : null"
              class="neon-glow-pink relative flex aspect-square cursor-pointer items-center justify-center rounded-lg bg-primary-container ring-2 ring-primary ring-offset-2 ring-offset-surface font-label-mono text-label-mono text-on-primary-container"
              [class]="cell.customClass"
              (click)="select(cell)"
            >
              {{ cell.day }}
              @if (cell.isToday) {
                <span class="absolute bottom-1 h-1 w-1 rounded-full bg-secondary-container"></span>
              }
            </button>
          }
          @case ('today') {
            <button
              type="button"
              aria-pressed="false"
              [attr.aria-label]="cell.ariaLabel"
              aria-current="date"
              class="neon-glow-cyan active-press relative flex aspect-square cursor-pointer items-center justify-center rounded-lg border-2 border-secondary-container font-label-mono text-label-mono text-secondary-fixed-dim transition-colors hover:bg-secondary-container/15"
              [class]="cell.customClass"
              (click)="select(cell)"
            >
              {{ cell.day }}
              <span class="absolute bottom-1 h-1 w-1 rounded-full bg-secondary-container"></span>
            </button>
          }
          @case ('available') {
            <button
              type="button"
              aria-pressed="false"
              [attr.aria-label]="cell.ariaLabel"
              class="active-press flex aspect-square cursor-pointer items-center justify-center rounded-lg font-label-mono text-label-mono text-on-surface transition-colors hover:bg-surface-container-highest hover:text-primary"
              [class]="cell.customClass"
              (click)="select(cell)"
            >
              {{ cell.day }}
            </button>
          }
          @default {
            <button
              type="button"
              disabled
              [attr.aria-label]="cell.ariaLabel"
              [class]="cell.customClass"
              class="flex aspect-square cursor-not-allowed items-center justify-center rounded-lg font-label-mono text-label-mono text-on-surface-variant/25"
            >
              {{ cell.day }}
            </button>
          }
        }
      } @else {
        <span aria-hidden="true"></span>
      }
    }
  </div>
</div>
